import { render, staticRenderFns } from "./IntendedUse.vue?vue&type=template&id=3ea79dc5&"
import script from "./IntendedUse.vue?vue&type=script&lang=ts&"
export * from "./IntendedUse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports